// Custom Complementary Upsell Add to Cart Functionality

const dispatchCustomEvent = function (eventName) {
  let data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const detail = {
    detail: data
  };
  const event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};

function initializeWearItWithProductItems() {
  if (typeof window.ProductItem === 'undefined') {
    setTimeout(initializeWearItWithProductItems, 100);
    return;
  }
  
  const wearItWithContainers = document.querySelectorAll('.wear_it_with');
  
  if (wearItWithContainers.length > 0) {
    wearItWithContainers.forEach(container => {
      const wrapper = container.querySelector('.wear-it-with--wrapper');
      if (!wrapper) return;
      
      if (wrapper.dataset.productItemInitialized === 'true') return;
      wrapper.dataset.productItemInitialized = 'true';

      const productItemInstance = window.ProductItem(wrapper);
      
      if (productItemInstance) {
        wrapper._productItemInstance = productItemInstance;
      }
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeWearItWithProductItems);
} else {
  initializeWearItWithProductItems();
}

const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.addedNodes.length) {
      const hasWearItWith = Array.from(mutation.addedNodes).some(node => {
        if (node.nodeType === 1) { // Element node
          return node.classList && node.classList.contains('wear_it_with') ||
                 node.querySelector && node.querySelector('.wear_it_with');
        }
        return false;
      });
      
      if (hasWearItWith) {
        initializeWearItWithProductItems();
      }
    }
  });
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

const wear_it_with = document.querySelectorAll('.wear_it_with');
if(wear_it_with.length > 0){
    wear_it_with.forEach(wrapper=>{
        const allWearItems = wrapper.querySelectorAll('.wear-it-with--item');
        if(allWearItems.length > 0){
            allWearItems.forEach(item=>{
                const AddToCartButton = item.querySelector('[data-complementary-add-to-cart]');
                if(AddToCartButton){
                    AddToCartButton.addEventListener('click', ()=>{
                        handleSubmitComplementary(item);
                    })
                }
            })
        }
    })
}

async function handleSubmitComplementary(item){
    // console.log(item);
    const size_option_dropdown = item.querySelector('.wear_it_size');
    if(size_option_dropdown){
        const selected_size_option = size_option_dropdown.options[size_option_dropdown.selectedIndex];
        if(selected_size_option){
            const VariantId = selected_size_option.getAttribute('data-variant-id');
            if(VariantId == null){
                const errorEle = item.querySelector('.add_to_cart_error');
                if(errorEle){
                    errorEle.innerText = window.theme.cartErorrs.size_error_text;
                    errorEle.removeAttribute('hidden');
                    setTimeout(()=>{
                        errorEle.setAttribute('hidden', true);
                    }, 1500)
                }
            } else{
                addItemById(VariantId, 1);
            }
        }
    }
}

function addItemById(id, quantity) {
  let data = {
    items: [{
      id,
      quantity
    }]
  };
  return fetch('/cart/add.js', {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(data)
  }).then(r => r.json()).then(res => {
    if (res.status == "422") {
      const error = {
        code: 422,
        message: res.description
      };
      handleError(error, "addItemById", id);
    }
})
.then(cart => {
  dispatchCustomEvent("apps:product-added-to-cart");
    let quick_cart = document.querySelector('[data-section-type="quick-cart"]');
    if(quick_cart) {
        quick_cart.classList.add('animation--quick-cart-revealed');
        quick_cart.querySelector('.quick-cart__wrapper').classList.add('active');
    }
});
}

function equalizeH4Heights() {
    const h4s = document.querySelectorAll('.custom-collection__content h4');
    
    // Reset heights first
    h4s.forEach(h4 => h4.style.height = 'auto');
    
    let rows = [];
    let currentTop = null;
    let currentRow = [];

    // Group elements row-wise based on top offset
    h4s.forEach(h4 => {
        const top = h4.getBoundingClientRect().top;

        if (currentTop === null || Math.abs(top - currentTop) < 5) {
            currentRow.push(h4);
            currentTop = top;
        } else {
            rows.push(currentRow);
            currentRow = [h4];
            currentTop = top;
        }
    });
    if (currentRow.length) {
        rows.push(currentRow);
    }

    // Set max height per row
    rows.forEach(row => {
        const maxHeight = Math.max(...row.map(h4 => h4.offsetHeight));
        row.forEach(h4 => h4.style.height = maxHeight + 'px');
    });
}

// Run on page load
window.addEventListener('load', equalizeH4Heights);

// Run on resize
window.addEventListener('resize', () => {
    // Use debounce to avoid performance issues
    clearTimeout(window.equalizeTimeout);
    window.equalizeTimeout = setTimeout(equalizeH4Heights, 100);
});

function matchParagraphHeights() {
    const paragraphs = document.querySelectorAll('.custom-collection__content p');

    // Reset all heights first
    paragraphs.forEach(p => {
        p.style.height = 'auto';
    });

    const rows = {};
    
    // Group paragraphs by their offsetTop (i.e., row position)
    paragraphs.forEach(p => {
        const top = p.getBoundingClientRect().top;
        if (!rows[top]) {
            rows[top] = [];
        }
        rows[top].push(p);
    });

    // For each row, set all <p> to the tallest height
    Object.values(rows).forEach(row => {
        const maxHeight = Math.max(...row.map(p => p.offsetHeight));
        row.forEach(p => {
            p.style.height = `${maxHeight}px`;
        });
    });
}

// Run on DOM ready
document.addEventListener("DOMContentLoaded", matchParagraphHeights);

// Run on window resize to re-adjust
window.addEventListener("resize", matchParagraphHeights);
